import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface ConflictDate {
  date: string;
  existingRecordCount: number;
  affectedEmployees: string[];
}

interface ConflictDialogData {
  conflicts: ConflictDate[];
  message: string;
}

@Component({
  selector: 'app-import-conflict-dialog',
  templateUrl: './import-conflict-dialog.component.html',
  styleUrls: ['./import-conflict-dialog.component.scss']
})
export class ImportConflictDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ImportConflictDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConflictDialogData
  ) {}

  onOverwrite(): void {
    this.dialogRef.close(true); // true = overwrite existing data
  }

  onSkip(): void {
    this.dialogRef.close(false); // false = skip conflicting dates
  }

  onCancel(): void {
    this.dialogRef.close(); // undefined = cancel import
  }

  getTotalConflicts(): number {
    return this.data.conflicts.reduce((total, conflict) => total + conflict.existingRecordCount, 0);
  }

  getTotalDates(): number {
    return this.data.conflicts.length;
  }
}
